'use strict';
const RequestManager = require('../helpers/request-manager');
const ParamsManager = require('../helpers/params-manager');
const errorHandler = require('../helpers/error-handler');

class Users {
  constructor(credentials, request, sdkConfiguration, customerId) {
    this.requestManager = new RequestManager(sdkConfiguration, request, credentials);
    this.paramsManager = new ParamsManager([customerId]);
  }

  setRole(role, user) {
    this.requestManager.requestConfigurationManager.setApi('SetUserRole');
    this.paramsManager.addPathParam(role);
    this.paramsManager.addBodyParams(user);
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

  create(userToCreate) {
    this.requestManager.requestConfigurationManager.setApi('CreateUser');
    this.paramsManager.addBodyParams(userToCreate);
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

}

module.exports = Users;
